import { useDrop } from 'react-dnd';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
/**
 * DroppableContainer component allows an area to accept draggable items and respond to drops.
 *
 * @param children ReactNode The content of the container, usually other components or text
 * @param onDrop function Callback function to be called when an item is dropped
 * @param accepts string or string[] The type(s) of items that this container can accept
 *
 * @returns JSX.Element The container that accepts draggable items
 */
export const DroppableContainer = ({ children, onDrop, accepts }) => {
    const [{ isOver }, drop] = useDrop({
        accept: accepts,
        drop: (item) => onDrop(item),
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    });

    return (
        <div
            ref={drop}
            className={`drop-container ${isOver ? 'drop-hover' : ''}`}
        >
            {children}
        </div>
    );
};
